const digest = 'a829bac1e02e5590954c77f7fbf71a0d300c11b0ada005e7cf2b2e3f4f2fe7a8';
const css = `._cardArt_odpyc_1{height:45px;margin:-1.5rem auto .5rem;max-width:unset}._radiusContainer_odpyc_7{border-radius:0 0 1rem 1rem}._accordionPanel_odpyc_11 h3{font-family:inherit!important;font-weight:500!important}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'cardArt': '_cardArt_odpyc_1', 'radiusContainer': '_radiusContainer_odpyc_7', 'accordionPanel': '_accordionPanel_odpyc_11' };
export const cardArt = '_cardArt_odpyc_1';
export const radiusContainer = '_radiusContainer_odpyc_7';
export const accordionPanel = '_accordionPanel_odpyc_11';
export { css, digest };